export default [{
  name: 'downloads.assets.guidelines',
  download: 'https://downloads.skycoin.com/branding/Skycoin-Brand_Guidelines-v1.6.pdf',
  filetype: '.pdf',
  filesize: '2.7mb',
},
{
  name: 'downloads.assets.branding',
  download: 'https://downloads.skycoin.com/branding/Skycoin-v1.6.1_zh.pdf',
  filetype: '.pdf',
  filesize: '3.3mb',
},
{
  name: 'downloads.assets.logo',
  download: 'https://downloads.skycoin.com/branding/Skycoin-Logos.zip',
  filetype: '.zip',
  filesize: '2.3mb',
},
{
  name: 'downloads.assets.sch_logo',
  download: 'https://downloads.skycoin.com/branding/SCH_Logo_Assets.zip',
  filetype: '.zip',
  filesize: '5.0mb',
},
{
  name: 'downloads.assets.font',
  download: 'https://downloads.skycoin.com/branding/Skycoin-Sans.zip',
  filetype: '.zip',
  filesize: '0.2mb',
}];



// WEBPACK FOOTER //
// ./src/components/Downloads/components/Assets/content.js